import axios from 'axios'

const apiKey = "2AE19CFC0C224B1D6585A4A899A565C6DE93BD5EFD97E7ECB0D797019822CD36";

const isDEV = false

export default () => {
    return axios.create({
      baseURL: isDEV ? `http://backoffice.accelery.host/api/` : `https://backoffice-dev.accelery.dev/api/`,
      headers: {
        "X-Api-Key": apiKey
      },
      timeout: 1000 * 190,
      withCredentials: true,
    })
  }